export default __webpack_public_path__ + "static/media/eu.6e7726ad.jpg";